import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-0.5 font-mono text-xs font-semibold uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
  {
    variants: {
      variant: {
        primary: "border-primary bg-primary text-primary-foreground",
        secondary: "border-secondary bg-secondary text-secondary-foreground",
        error: "border-error bg-error text-error-foreground",
        // See toast.ts — the raw signal token is a fill, not a text colour.
        warning: "border-warning bg-warning-soft text-warning-strong",
        info: "border-info bg-info-soft text-info-strong",
        success: "border-success bg-success-soft text-success-strong",
      },
      outline: {
        true: "bg-transparent",
      },
    },
    compoundVariants: [
      { outline: true, variant: "primary", className: "text-primary" },
      { outline: true, variant: "secondary", className: "text-secondary" },
      { outline: true, variant: "error", className: "text-error" },
      // Outline drops the fill, so these are the signal token as bare text on
      // the page — the worst case for it (amber-500 on zinc-50 is ~2:1).
      { outline: true, variant: "warning", className: "text-warning-strong" },
      { outline: true, variant: "info", className: "text-info-strong" },
      { outline: true, variant: "success", className: "text-success-strong" },
    ],
    defaultVariants: {
      variant: "primary",
      outline: false,
    },
  },
);
